import { render, staticRenderFns } from "./NotificationsGroupCardTitle.vue?vue&type=template&id=748276ea&scoped=true"
import script from "./NotificationsGroupCardTitle.vue?vue&type=script&lang=js"
export * from "./NotificationsGroupCardTitle.vue?vue&type=script&lang=js"
import style0 from "./NotificationsGroupCardTitle.vue?vue&type=style&index=0&id=748276ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748276ea",
  null
  
)

export default component.exports